import { useEffect, useState } from "react";
import { Col, Row, Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { ImprovementPlanActionFormDto } from "../types";
import { GenericSaveButton } from "../../../components/common/GenericSaveButton";
import './ImprovementPlanProposeActions.css';
import { getImprovementActionsFromAI } from "../api/improvementPlanAPI";
import { ApiErrorResponse } from "../../../types/ApiErrorResponse";
import { addImprovementActions, setProposedActionsPage } from "../../../redux/improvementPlanSlice";

export default function ImprovementPlanProposeActions() {
    const { t } = useTranslation(["improvementPlan", "common"]);
    const dispatch = useDispatch();
    const improvementPlanForm = useSelector((state: RootState) => state.improvementPlanForm.data);

    const [isLoading, setLoading] = useState<boolean>()
    const [proposedActions, setProposedActions] = useState<ImprovementPlanActionFormDto[]>([])
    const [selectedActions, setSelectedActions] = useState<ImprovementPlanActionFormDto[]>([])

    useEffect(() => {
        setLoading(true);
        getImprovementActionsFromAI(improvementPlanForm)
            .then((data) => {
                setProposedActions(data);
            }).catch((error: ApiErrorResponse) => {
                console.log(error)
            }).finally(() => {
                setLoading(false);
            })
    }, [])
    const saveActions = () => {
        dispatch(addImprovementActions({ actions: selectedActions }));
        dispatch(setProposedActionsPage({ proposedActionsPage: false }));
    }

    const toggleAction = (action: ImprovementPlanActionFormDto) => {
        setSelectedActions((prev) => {
            const exists = prev.some(
                selectedAction => selectedAction.description === action.description
            );

            if (exists) {
                return prev.filter(
                    selectedAction => selectedAction.description !== action.description
                );
            }

            return [...prev, action];
        });
    };
    
    return (
        <>        
            {isLoading && (
                <div className="overlay-spinner">
                    <Spinner animation="border" variant="light" />
                </div>
            )}
            <Row className="mb-2 d-flex align-items-center justify-content-between">
                <Col xs="auto">
                    <h5 className="mb-0">{t("improvementPlan:proposeActions.title")}</h5>
                </Col>
                <Col xs="auto">
                    <GenericSaveButton
                        onClick={saveActions}
                        onCancelClick={() => dispatch(setProposedActionsPage({ proposedActionsPage: false }))}
                        cancelLabel={t("common:buttons.buttonCancel")}
                        saveLabel={t("improvementPlan:proposeActions.saveActions")}
                    />
                </Col>
            </Row>
            <Row className="mt-1">
                <Col xs={6}>
                    <div>
                        <p className="panel-title">{t("improvementPlan:proposeActions.improvementActions")}</p>
                        <div className="actions-list">
                            {proposedActions.map((action, index) => {
                                const isSelected = selectedActions.some(selectedAction => selectedAction.description == action.description);
                                return (
                                    <div
                                        key={action.id}
                                        className="action-item"
                                        style={{
                                            borderBottom: index < proposedActions.length - 1 ? "1px solid #e8e8e4" : "none",
                                            display: isSelected ? "none" : "flex"
                                        }}
                                    >
                                        <span className="action-text">{action.description}</span>
                                        <button
                                            onClick={() => toggleAction(action)}
                                            className="action-btn"
                                        >
                                            <i className="bi bi-chevron-double-right"></i>
                                        </button>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </Col>
                <Col xs={6}>
                    <div>
                        <p className="panel-title">{t("improvementPlan:proposeActions.selectedActions")}</p>
                        <div className="selected-list">
                            {(selectedActions || []).length === 0 ? (
                                <span className="empty-state">{t("improvementPlan:proposeActions.withoutActions")}</span>
                            ) : (
                                (selectedActions || []).map((action) => (
                                <div key={action.id} className="selected-item">
                                    <span className="selected-sext">{action.description}</span>
                                    <button
                                        onClick={() => toggleAction(action)}
                                        className="remove-btn"
                                        title="Eliminar"
                                    >
                                        <i className="bi bi-x-lg"></i>
                                    </button>
                                </div>
                                ))
                            )}
                        </div>
                    </div>
                </Col>
            </Row>
        </>
    );    
}